<template>
    <div id="sgushennoe">
        <section class="welcome">
            <div class="bg"><span></span></div>
            <div class="start">
                <h1><span>Сгущенное молоко, <b>любимое с&nbsp;детства</b></span></h1>

                <div class="text">Любимое лакомство времен Советского Союза и&nbsp;сегодня остается одним из&nbsp;самых востребованных. Нежный сливочный вкус, идеальная кремовая консистенция, а&nbsp;в&nbsp;составе&nbsp;&mdash; ничего лишнего: только цельное молоко и&nbsp;сахар&nbsp;&mdash; все в&nbsp;полном соответствии с&nbsp;нормами ГОСТа.</div>

                <h3>В&nbsp;полном соответствии с&nbsp;нормами ГОСТа</h3>

                <div class="block">Со&nbsp;сгущенным молоком &laquo;Алексеевское&raquo; устраивают чаепития, добавляют в&nbsp;виде топпингов к&nbsp;блинчикам, сырникам или в&nbsp;каши, с&nbsp;ним&nbsp;же готовят вкусные десерты. Более полувека &laquo;Алексеевское&raquo; сохраняет традиции качества, оставаясь поистине народным брендом &#8470;1: торговая марка неоднократно становилась победителем программы &laquo;Контрольная закупка&raquo;.</div>
            </div>

            <div class="list">
                <h2>Награды</h2>
                <div class="item item-img1">
                    <div class="item-content">
                        <h3>Сгущенное молоко цельное</h3>
                        <p>Диплом I&nbsp;степени и&nbsp;золотая медаль &laquo;Российской агропромышленной выставки&raquo;, 2000&nbsp;г.</p>
                        <p>Диплом I&nbsp;степени и&nbsp;золотая медаль Российской агропромышленной выставки &laquo;Золотая осень&raquo;, 2002&nbsp;г.</p>
                        <p>Лауреат Всероссийского конкурса &laquo;100 лучших товаров России&raquo;, 2003, 2005, 2007, 2010, 2012&nbsp;гг.</p>
                        <p>Диплом и&nbsp;золотая медаль &laquo;Российская агропромышленная выставка &laquo;Золотая осень&raquo;, 2006&nbsp;г.</p>
                        <p>Разрешение на&nbsp;нанесение знака &laquo;Белгородский стандарт&raquo;, 2007-2008&nbsp;гг.</p>
                        <p>Золотые медали в&nbsp;Международном конкурсе &laquo;Лучший продукт&raquo; в&nbsp;рамках 16, 21 и&nbsp;27-й Международной 
                        выставки продуктов питания, напитков и&nbsp;сырья для их&nbsp;производства &laquo;Продэкспо-2009&raquo;, 
                        &laquo;Продэкспо-2014&raquo; и&nbsp;&laquo;Продэкспо-2020&raquo;.</p>
                        <p>Победитель программы &laquo;Контрольная закупка&raquo;, посвященной цельному сгущенному молоку с&nbsp;сахаром 2008, 2014, 2016&nbsp;гг.</p>
                    </div>
                </div>
                <div class="item item-img2">
                    <div class="item-content">
                        <h3>Сгущенное молоко вареное</h3>
                        <p>Золотая медаль в Международном конкурсе &laquo;Лучший продукт&raquo; в&nbsp;рамках 26-й&nbsp;Международной
                        выставки продуктов питания, напитков и&nbsp;сырья для их&nbsp;производства &laquo;Продэкспо-2019&raquo;.</p>
                    </div>
                </div>
            </div>


            
            <div class="lenta">

                <news></news>

                <!--<div class="lenta-logo"></div>-->
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "CondensedMilk"
    }
</script>